export default __webpack_public_path__ + "static/media/email-b.eb67ba18.svg";